const buttons = document.querySelectorAll('.tooltip-button');

/**
 * Tooltips
 * fix pagedone tooltips on mobile (add touch events instead of hovers)
 */
const Tooltips = {
	init() {
		if (!buttons.length) return;

		buttons.forEach((button) => {
			const tooltip = button.nextElementSibling;
			if (!tooltip || !tooltip.classList.contains('tooltip-box')) return;

			let isTouch = false;

			// Détection de l'événement tactile
			button.addEventListener('touchstart', (e) => {
				isTouch = true;
				e.preventDefault(); // Empêche le clic direct sur le lien
				this.toggleTooltip(button, tooltip);
			});

			// Si clic après un touch, n'ouvre pas le lien immédiatement
			button.addEventListener('click', (e) => {
				if (isTouch) {
					e.preventDefault();
					isTouch = false;
				}
			});
		});

		// Ferme les tooltips si clic en dehors
		document.addEventListener('click', (e) => {
			if (!e.target.closest('.tooltip-box')) {
				document.querySelectorAll('.tooltip-box.visible').forEach((t) => {
					t.classList.add('invisible');
					t.classList.remove('visible');
				});
			}
		});
	},

	toggleTooltip(button, tooltip) {
		const isVisible = tooltip.classList.contains('visible');
		document.querySelectorAll('.tooltip-box.visible').forEach((t) => {
			t.classList.add('invisible');
			t.classList.remove('visible');
		});
		if (!isVisible) {
			tooltip.classList.remove('invisible');
			tooltip.classList.add('visible');
		}
	},
};

export default Tooltips;
